import { useState } from "react";
import axios from "axios";
import { Toaster, toast } from "sonner";
import { Reveal } from "@/lib/reveal";
import { useLang } from "@/lib/lang";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY = { name: "", email: "", phone: "", country: "", subject: "", message: "" };

export default function Contact() {
  const { t, lang } = useLang();
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const c = t.contact;

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.subject || !form.message) {
      toast.error(c.fill);
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success(c.successMsg);
      setForm(EMPTY);
    } catch (err) {
      toast.error(err?.response?.data?.detail || c.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="pad section-line" id="contact" data-testid="contact-section">
      <Toaster position="top-center" theme="dark" richColors dir={lang === "he" ? "rtl" : "ltr"} />
      <div style={{ maxWidth: 640 }}>
        <Reveal className="eyebrow">{c.eyebrow}</Reveal>
        <Reveal delay={0.05}>
          <h2 className="big" data-testid="contact-title">{c.title}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="body" style={{ marginBottom: 40 }}>{c.body}</p>
        </Reveal>
      </div>

      <Reveal delay={0.12}>
        <form className="qs-form" onSubmit={submit} data-testid="contact-form">
          <div className="grid2">
            <input type="text" placeholder={c.placeholders.name} value={form.name} onChange={set("name")} data-testid="input-name" required />
            <input type="email" placeholder={c.placeholders.email} value={form.email} onChange={set("email")} data-testid="input-email" required />
          </div>
          <div className="grid2">
            <input type="tel" placeholder={c.placeholders.phone} value={form.phone} onChange={set("phone")} data-testid="input-phone" />
            <input type="text" placeholder={c.placeholders.country} value={form.country} onChange={set("country")} data-testid="input-country" />
          </div>
          <select value={form.subject} onChange={set("subject")} data-testid="input-subject" required
            style={{ color: form.subject ? "var(--text)" : "#8f877d" }}>
            <option value="" disabled>{c.placeholders.subjectDefault}</option>
            {c.subjects.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <textarea placeholder={c.placeholders.message}
            value={form.message} onChange={set("message")} data-testid="input-message" required />
          <button type="submit" className="btn" disabled={loading} data-testid="contact-submit">
            {loading ? c.sending : c.submit}
          </button>
        </form>
      </Reveal>

      <footer className="qs-footer" data-testid="footer">
        <div className="logo">{c.footerName}</div>
        <div className="copy">© {new Date().getFullYear()} {t.logo}. {c.rights}</div>
      </footer>
    </section>
  );
}
